import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicEmail({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13 2.25c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75V4c0-.97.78-1.75 1.75-1.75h10zm.25 4.15L8.97 9.25c-.59.4-1.35.4-1.94 0L2.75 6.4V12c0 .14.11.25.25.25h10c.14 0 .25-.11.25-.25V6.4zM13 3.75H3a.25.25 0 00-.25.25v.6L7.86 8c.07.05.15.06.23.03l.05-.02 5.11-3.41V4a.25.25 0 00-.25-.25z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicEmail.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicEmail.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicEmail svgRef={ref} {...props} />);
export default ForwardRef;
